import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from "@angular/forms";
import { ColumnComponent, GridComponent, RowArgs, ScrollRequest, SelectAllCheckboxState } from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query";
import * as moment from "jalali-moment";
import { Moment } from "jalali-moment";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { GridColumnInfo, GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { AccountService, HttpCommonService, PagingDataResult, ShowToastrService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccVoucherDetail } from "../../models/accvoucherdetail.model";
import { SubLedgerStandardComment } from "../../models/subLedger-standard-comment.model";
import { SubLedger } from "../../models/subledger.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "accvoucher-detail",
  templateUrl: "./accvoucher-detail.component.html",
  styleUrls: ["./accvoucher-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccVoucherDetailComponent implements OnInit {
  dataReadedColumns: string = "";
  _GridColumnInfo: GridColumnInfo;
  isFirstLoad: boolean;
  LookupData: Dictionary = [];
  LookupIsLoading: Dictionary = [];
  DefaultValues: Dictionary = [];
  @ViewChild("grid") public grid: GridComponent;
  public isNew: boolean;
  public rowinserted: boolean = false;
  isDisabled: boolean = false;
  public mySelection: number[] = [];
  public selectAllState: SelectAllCheckboxState = "unchecked";
  isLOading: boolean = false;
  ngUnsubscribe = new Subject<void>();
  @Output() valueChanges = new EventEmitter<any>();
  @Input() RowNumberName: string;
  @Input() columns: form_control[] = [];
  @Input() isAdd: boolean = true;
  @Input() isEdit: boolean = false;
  @Input() isDelete: boolean = true;
  @Input() isPriceable: boolean = false;
  @Input() hasDiscount: boolean = false;
  @Input() hasReference: boolean = false;
  @Input() hasReferenceRequired: boolean = false;
  @Input() IsPurchaseInvoice: boolean = false;
  @Input() IsReturnPurchaseInvoice: boolean = false;
  @Input() headerTitleToDetailTitle: string;
  @Input() accountInfo: string;
  @Output() showDetail = new EventEmitter<void>();
  triggerShowDetail() {
    this.showDetail.emit();
  }
  formGroup: UntypedFormGroup;
  _dataList: AccVoucherDetail[];
  loadingData: boolean = false;
  @Input()
  get dataList(): AccVoucherDetail[] {
    return this._dataList;
  }
  set dataList(value: AccVoucherDetail[]) {
    this._dataList = value;
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
  }
  _gridheight: number = 57;
  @Input()
  get gridheight(): number {
    return this._gridheight;
  }
  set gridheight(value: number) {
    this._gridheight = value;
  }
  gridData: AccVoucherDetail[];
  aggregatesColumnName: string = "RowNumber,Debit,Credit";
  rowIsEditing: boolean = false;
  editedRow: AccVoucherDetail;
  editedRowIndex: number = 0;
  public state: State = {
    skip: 0,
    take: 5,
    filter: {
      logic: "and",
      filters: [],
    },
    group: [],
  };
  get getTaxRate(): number {
    return this.missetup.getnumber("GNR", "TaxRate") / 100;
  }

  DetailControlModels: Dictionary;

  getGridCell(index) {
    return this.grid.columns.toArray()[index];
  }

  getColumnIndex(colIndex: number) {
    let index: number = -1;
    let ColumnName: string;
    this.grid.columns
      .toArray()
      .filter((x) => x.isVisible)
      .forEach((x) => {
        index = index + 1;
        if (index == colIndex) ColumnName = x["field"];
      });
    return ColumnName;
  }

  @HostListener("window:keydown", ["$event"])
  cArrowDown(e: KeyboardEvent) {
    if (document.hidden) return;

    if (e.altKey && e.shiftKey && (e.key === "n" || e.key === "N" || e.key === "أ")) {
      e.preventDefault();
      this.addHandler();
    }
    if (e.ctrlKey && e.altKey && (e.key === "s" || e.key === "S" || e.key === "س")) {
      e.preventDefault();
      this.saveCurrent();
    }
    if (e.ctrlKey && (e.key === "c" || e.key === "C" || e.key === "ز")) {
      e.preventDefault();
      this.copyHandler();
    }
    if (e.ctrlKey && (e.key === "v" || e.key === "V" || e.key === "ر")) {
      e.preventDefault();
      this.pasetHandler();
    }
    if (e.key === "Tab" && !e.shiftKey) {
      if (this.formGroup) {
        e.preventDefault();
        // this.setDisableColumn(this.formGroup.value);
        if (this.getColumnIndex(this.grid.activeCell?.colIndex) === "Debit" || this.getColumnIndex(this.grid.activeCell?.colIndex) === "Credit") {
          if (this.formGroup.valid) {
            if (this.formGroup.controls["Debit"].value || this.formGroup.controls["Credit"].value) {
              this.saveCurrent();

              if (this.grid.activeCell.rowIndex < this.dataList.length) {
                this.cd.markForCheck();
                this.editHandler({ sender: this.grid, rowIndex: this.grid.activeRow.index, dataItem: this.gridData[this.grid.activeRow.index] });
              } else {
                this.addHandler();
              }
            }
          } else {
            this.sts.showToast(
              "danger",
              this.translate.instant("MessageHeader.Error"),
              `شرح قلم ${this.translate.instant("Errors.Required")}`
              //TODO IT Should Work on Every Required Field Which is Empty
            );
          }
        } else {
          this.grid.focusPrevCell(true);
          if (this.grid.activeCell) {
            let { name, disabled } = this.columns.filter((col) => col.listVisible && col.formVisible).sort((a, b) => a.order - b.order)[
              this.grid.activeCell.colIndex - 1
            ];
            if (disabled) {
              this.cArrowDown(e);
            }
            let stLookup = document.getElementById(`id${name}`);
            if (!stLookup) {
              return;
            }
            const input = stLookup.getElementsByTagName("input").item(0) as HTMLInputElement;
            input.click();
            this.cd.markForCheck();
          }
        }
      }
    }
    if (e.key.toUpperCase() === "F3") {
      e.preventDefault();
      this.changeDebit();
    }
    if (e.key.toUpperCase() === "F4") {
      e.preventDefault();
      if (this.dataList.length > 1 && this.formGroup.controls["RowNumber"].value > 1) {
        let ColumnName = this.getColumnIndex(this.grid.activeCell.colIndex);
        if (
          (ColumnName !== "Debit" && ColumnName !== "Credit") ||
          (ColumnName === "Debit" && !this.formGroup.controls["Credit"].value) ||
          (ColumnName === "Credit" && !this.formGroup.controls["Debit"].value)
        ) {
          if (ColumnName.includes("SubLedger") || ColumnName.includes("DetailLedger")) {
            let PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName];
            this.formGroup.controls[ColumnName].setValue(PrevValue);
            PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName.replace("Id", "Code")];
            this.formGroup.controls[ColumnName.replace("Id", "Code")].setValue(PrevValue);
            PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName.replace("Id", "Title")];
            this.formGroup.controls[ColumnName.replace("Id", "Title")].setValue(PrevValue);

            if (ColumnName.includes("SubLedger")) {
              let PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2]["HasDetailLedger1"];
              this.formGroup.controls["HasDetailLedger1"].setValue(PrevValue);
              PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2]["HasDetailLedger2"];
              this.formGroup.controls["HasDetailLedger2"].setValue(PrevValue);
              PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2]["HasDetailLedger3"];
              this.formGroup.controls["HasDetailLedger3"].setValue(PrevValue);
              PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2]["HasDetailLedger4"];
              this.formGroup.controls["HasDetailLedger4"].setValue(PrevValue);
              PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2]["HasDetailLedger5"];
              this.formGroup.controls["HasDetailLedger5"].setValue(PrevValue);
              PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2]["HasDetailLedger6"];
              this.formGroup.controls["HasDetailLedger6"].setValue(PrevValue);
              PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2]["HasDetailLedger7"];
              this.formGroup.controls["HasDetailLedger7"].setValue(PrevValue);
              this.setDisableColumn(this.formGroup.value);
            }
          } else {
            let PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName];
            this.formGroup.controls[ColumnName].setValue(PrevValue);
            if (this.grid.activeRow.dataItem) this.grid.activeRow.dataItem[ColumnName] = PrevValue;
          }
          this.selectorService.onSubmited.next(true);
          this.cd.markForCheck();
        }
      }
    }
    if (e.key.toUpperCase() === "F5") {
      e.preventDefault();
      if (!this.formGroup || !this.gridData || this.gridData.length < 2) return;
      Object.keys(this.dataList[0])
        .filter((x) => x !== "RowNumber" && x !== "Id" && x !== "State")
        .forEach((key) => {
          if (key && this.formGroup.controls[key]) {
            let PrevValue = this.gridData[this.formGroup.controls["RowNumber"].value - 2][key];
            this.formGroup.controls[key].setValue(PrevValue);
            if (this.grid.activeRow.dataItem) this.grid.activeRow.dataItem[key] = PrevValue;
          }
        });
      this.cd.markForCheck();
    }
    if (this.formGroup && e.ctrlKey && e.key.toUpperCase() === "DELETE") {
      e.preventDefault();
      this.removeHandler({ sender: this.grid, dataItem: this.formGroup.value });
    }
    if (this.formGroup && e.key.toUpperCase() === "F7") {
      e.preventDefault();
      this.saveSubLedgerStandardComment();
    }
    if (this.grid?.activeCell?.rowIndex !== this.editedRowIndex && this.gridData[this.editedRowIndex - 1]) {
      this.valueChanges.emit(this.gridData[this.editedRowIndex - 1]);
    }
  }
  constructor(
    private sts: ShowToastrService,
    private missetup: MisSetupService,
    private accountService: AccountService,
    private selectorService: SelectorService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private _httpCommonService: HttpCommonService,
    private translate: TranslateService
  ) {
    this.onDataStateChange = this.onDataStateChange.bind(this);
    this.shouldBeChangedData = this.shouldBeChangedData.bind(this);
  }
  @Input() detailLedgerLevel: number = 0;

  ngOnInit(): void {
    this.mySelection = [];
    this.rowIsEditing = false;
    this.DefaultValues["AccVoucherHeaderId"] = 0;
    this.DefaultValues["RowNumber"] = 1;
    this.DefaultValues["Debit"] = 0;
    this.DefaultValues["Credit"] = 0;
    if (!this.dataList) this.dataList = [];
    this.setColumnWith();
    this.columns.forEach((x) => {
      if (x.listVisible && x.apiName) this.setDropdownlist(x.apiName, x.name);
    });
    if (this.dataList.length <= 0) setTimeout(() => this.addHandler(), 100);
  }
  changeDebit() {
    if (this.formGroup && this.grid && this.grid.isEditing) {
      let debit = this.formGroup.controls["Debit"].value;
      let credit = this.formGroup.controls["Credit"].value;
      this.formGroup.controls["Debit"].setValue(credit);
      this.formGroup.controls["Credit"].setValue(debit);
      if (this.formGroup.controls["Debit"].value !== credit) this.formGroup.controls["Debit"].setValue(credit);
      if (this.formGroup.controls["Credit"].value !== debit) this.formGroup.controls["Credit"].setValue(debit);
      if (this.grid?.activeRow?.dataItem) {
        this.grid.activeRow.dataItem.Credit = debit;
        this.grid.activeRow.dataItem.Debit = credit;
      }

      this.cd.markForCheck();
    }
  }
  setColumns() {
    this.columns.forEach((x) => {
      if (x.name === "DetailLedgerId") x.listVisible = this.detailLedgerLevel > 0;
      if (x.name === "DetailLedger2Id") x.listVisible = this.detailLedgerLevel > 1;
      if (x.name === "DetailLedger3Id") x.listVisible = this.detailLedgerLevel > 2;
      if (x.name === "DetailLedger4Id") x.listVisible = this.detailLedgerLevel > 3;
      if (x.name === "DetailLedger5Id") x.listVisible = this.detailLedgerLevel > 4;
      if (x.name === "DetailLedger6Id") x.listVisible = this.detailLedgerLevel > 5;
      if (x.name === "DetailLedger7Id") x.listVisible = this.detailLedgerLevel > 6;
    });
    return this.columns;
  }

  setValidators(key: string, validator: boolean) {
    if (this.formGroup && this.formGroup.controls[key]) {
      this.formGroup.controls[key].clearValidators();
      if (validator) this.formGroup.controls[key].setValidators(Validators.required);
      this.formGroup.controls[key].updateValueAndValidity();
    }
  }
  setFormGroup(entity: any = null) {
    let group: any = {};
    this.columns.forEach((question) => {
      switch (question.textType) {
        case "text":
          {
            let validator: ValidatorFn[] = [];
            if (question.required) validator.push(Validators.required);
            if (question.minLength && question.minLength > 0) validator.push(Validators.minLength(question.minLength));
            if (question.maxLength && question.maxLength > 0) validator.push(Validators.maxLength(question.maxLength));
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));

            group[question.name] = question.required
              ? new UntypedFormControl(!entity ? null : entity[question.name] || null, validator)
              : new UntypedFormControl(!entity ? null : entity[question.name] || null);
          }
          break;
        case "checkbox":
          group[question.name] = question.required
            ? new UntypedFormControl(!entity ? false : entity[question.name] || false, Validators.required)
            : new UntypedFormControl(!entity ? false : entity[question.name] || false);
          break;
        case "number":
          {
            let validator: ValidatorFn[] = [];
            if (question.required) validator.push(Validators.required);
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));

            group[question.name] = question.required
              ? new UntypedFormControl(!entity ? null : entity[question.name], validator)
              : new UntypedFormControl(!entity ? this.DefaultValues[question.name] : entity[question.name] ?? this.DefaultValues[question.name]);
          }
          break;
        case "date":
          group[question.name] = question.required
            ? new UntypedFormControl(entity[question.name], Validators.required)
            : new UntypedFormControl(entity[question.name]);
          break;
        default:
          group[question.name] = question.required
            ? new UntypedFormControl(!entity ? null : entity[question.name] || null, Validators.required)
            : new UntypedFormControl(!entity ? null : entity[question.name] || null);
          break;
      }
    });

    group["AccVoucherHeaderId"] = new UntypedFormControl(!entity ? 0 : entity["AccVoucherHeaderId"] || 0);
    group["State"] = new UntypedFormControl(!entity ? RowState.New : entity["State"] || RowState.NoChange);
    group["Id"] = new UntypedFormControl(!entity ? 0 : entity["Id"] || 0);
    group["RowVersion"] = new UntypedFormControl(!entity ? "" : entity["RowVersion"] || "");

    if (this.RowNumberName) group[this.RowNumberName] = new UntypedFormControl(!entity ? this.gridData.length + 1 : entity[this.RowNumberName] || 0);
    this.formGroup = new UntypedFormGroup(group);
    this.setChanges();
  }
  setColumnWith() {
    this.columns.forEach((x) => {
      if (
        x.textType === "number" &&
        x.withComma &&
        !x.name.toUpperCase().includes("NUMBER") &&
        !x.name.toUpperCase().includes("CODE") &&
        !x.name.toUpperCase().includes(".ID")
      )
        x.format = "#,#.#####";
      else x.format = "";
      if (!x.columnWidth || x.columnWidth <= 100) {
        if (x.textType === "text") x.columnWidth = 400;
        else x.columnWidth = 200;

        if (x.name === "RowNumber") x.columnWidth = 100;
        if (x.name === "TrackNo") x.columnWidth = 100;
        if (x.name === "TrackDate") x.columnWidth = 120;
      }
      //x.tabOrder = -1;
    });
    setTimeout((x) => this.fitColumns(), 100);
  }

  public addHandler() {
    this.closeEditor();
    this.isNew = true;
    if (!this.dataList) this.dataList = [];

    this.rowIsEditing = true;
    let _comment: string = "";
    if (this.headerTitleToDetailTitle) _comment = this.headerTitleToDetailTitle;
    const temp = <AccVoucherDetail>{
      Id: -1,
      RowNumber:
        this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length > 0
          ? this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length + 1
          : 1,
      State: RowState.New,
      Comment: _comment,
    };
    this.dataList.push(temp);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    this.editedRowIndex = this.gridData.length - 1;
    // this.fitColumns();
    this.cd.markForCheck();
    this.setFormGroup(temp);
    if (this.grid) {
      this.grid.editRow(this.editedRowIndex, this.formGroup);
    }
    // const keyboardEvent = new KeyboardEvent('keydown', {
    //   code: 'Tab',
    //   key: 'Tab',
    //   keyCode: 9,
    //   view: window,
    //   bubbles: true
    // });
    // document.activeElement.dispatchEvent(keyboardEvent);
  }

  public cancelHandler() {
    this.closeEditor();
  }
  setChanges() {
    let isDisablelingColumn: boolean = false;
    this.formGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && !isDisablelingColumn) {
        isDisablelingColumn = true;
        this.setDisableColumn(x);
        isDisablelingColumn = false;
      }
    });
    this.fitColumns();
    this.cd.markForCheck();
  }

  public saveHandler(rowIndex, formGroup): void {
    if (this.formGroup && this.formGroup?.valid) {
      var entity = formGroup.value;

      if (entity.State === undefined || (entity.State === RowState.New && rowIndex === -1)) {
        entity.State = RowState.New;
        if (!this.gridData.some((x) => x.RowNumber === entity.RowNumber)) {
          this.dataList.push(entity);
        }
      } else if (rowIndex >= 0) {
        if (!entity.State) entity.State = this.dataList[rowIndex].State;

        if (entity.State != RowState.New) (entity as AccVoucherDetail).State = RowState.Modify;
        if (entity.Id > 0 && this.dataList.some((x) => x.Id === entity.Id)) {
          this.dataList.forEach((m) => {
            if (m.Id === entity.Id) {
              Object.assign(m, entity);
            }
          });
        } else {
          this.dataList.forEach((m) => {
            if (m.RowNumber === entity.RowNumber && m.Id === entity.Id && m.State === entity.State) {
              if (entity.Id == -1) entity.Id = 0;
              Object.assign(m, entity);
            }
          });
        }
      }
      this.rowIsEditing = false;
      this.valueChanges.emit(entity);
      this.closeEditor();
      let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
      this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
      this.fitColumns();
      this.cd.markForCheck();
    } else this.sts.showDialog(`اطلاعات وارده صحیح نیست.`, "خطا", DialogType.alert);
  }
  setDisableColumn(value: AccVoucherDetail) {
    this.grid.columns.forEach((c) => {
      if (c["field"] === "Debit") {
        if (value.Credit && value.Credit > 0) this.setValue("Debit", 0);
        c["editable"] = !value.Credit || value.Credit <= 0;
      }
      if (c["field"] === "Credit") {
        if (value.Debit && value.Debit > 0) this.setValue("Credit", 0);
        c["editable"] = !value.Debit || value.Debit <= 0;
      }

      if (c["field"] === "DetailLedgerId") c["editable"] = value.HasDetailLedger1;
      if (c["field"] === "DetailLedger2Id") c["editable"] = value.HasDetailLedger2;
      if (c["field"] === "DetailLedger3Id") c["editable"] = value.HasDetailLedger3;
      if (c["field"] === "DetailLedger4Id") c["editable"] = value.HasDetailLedger4;
      if (c["field"] === "DetailLedger5Id") c["editable"] = value.HasDetailLedger5;
      if (c["field"] === "DetailLedger6Id") c["editable"] = value.HasDetailLedger6;
      if (c["field"] === "DetailLedger7Id") c["editable"] = value.HasDetailLedger7;

      if (c["field"] === "TrackNo") {
        c["editable"] = value.HasTrackNo;
        c["value"] = value.RequireTrackNo;
        //this.setValidators('TrackNo', value.RequireTrackNo)
      }
      if (c["field"] === "TrackDate") {
        c["editable"] = value.HasTrackNo;
        c["value"] = value.RequireTrackNo;
        //this.setValidators('TrackDate', value.RequireTrackNo);
      }
    });
    this.formGroup.updateValueAndValidity();
  }
  deleteFormHelper(dataItem: any) {
    this.dataList.forEach((x) => {
      if ((dataItem.Id > 0 && x.Id === dataItem.Id) || x === dataItem || this.mySelection.some((s) => x.RowNumber == s)) {
        if (x.State === RowState.New) x.State = RowState.Detached;
        else x.State = RowState.Delete;
      }
    });
    this.setRowNumber();
  }
  public removeHandler({ sender, dataItem }): void {
    if (sender.activeCell.colIndex <= 1) {
      this.sts.showDialog(`آیا از حذف اطلاعات اطمینان دارید؟`, "حذف اطلاعات", DialogType.confirm, () => this.deleteFormHelper(dataItem));
      sender.cancelCell();
    }
  }

  private setRowNumber() {
    let index: number = 0;
    this.gridData
      .filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
      .sort((a, b) => a.RowNumber - b.RowNumber)
      .forEach((x) => {
        index += 1;
        if (x.State !== RowState.New && x.State !== RowState.Modify) x.State = RowState.Modify;
        x.RowNumber = index;
      });
    this.valueChanges.emit(this.gridData[this.gridData.length - 1]);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
  }
  private closeEditor() {
    this.editedRow = undefined;
    this.grid.closeRow(this.editedRowIndex);
    this.rowIsEditing = false;
    this.isNew = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
    this.dataList = this.dataList.filter((x) => x.Id >= 0);
    if (this.dataList) {
      if (this.rowinserted) {
        this.dataList = this.dataList.filter((x) => x.Id >= 0);
        this.setRowNumber();
        this.rowinserted = false;
      } else {
        this.dataList = this.dataList.filter((x) => x.Id >= 0);
        let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.Id >= 0);
        this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
      }
    }
    this.cd.markForCheck();
  }

  public saveCurrent(): void {
    if (this.formGroup) {
      this.saveHandler(this.editedRowIndex, this.formGroup);
    }
  }
  public cellCloseHandler(args: any) {
    const { formGroup, dataItem } = args;
    if (!formGroup) return;
    if (!formGroup.valid) {
      return;
    } else if (formGroup.dirty) {
      this.saveCurrent();
    } else this.closeEditor();
  }
  public editHandler({ sender, rowIndex, dataItem }) {
    this.editedRow = undefined;
    if (this.formGroup && this.editedRowIndex !== undefined && this.editedRowIndex >= 0 && this.editedRowIndex !== rowIndex)
      this.cellCloseHandler({ formGroup: this.formGroup, dataItem: dataItem });
    if (this.rowIsEditing) return;
    if (dataItem) this.valueChanges.emit(dataItem);
    if (!this.isAdd && !this.isEdit) {
      this.valueChanges.emit(dataItem);
      return;
    }
    this.setFormGroup(dataItem);
    //if (this.formGroup && !this.formGroup?.valid)
    //  return;

    this.rowIsEditing = true;
    this.editedRowIndex = rowIndex;
    this.valueChanges.emit(dataItem);
    sender.editRow(rowIndex, this.formGroup);
  }
  public doubleclic(args: any) {
    this.editedRow = undefined;
    if (this.editedRowIndex !== undefined && this.editedRowIndex >= 0 && this.editedRowIndex !== this.grid.activeRow.index - 1)
      this.cellCloseHandler({ formGroup: this.formGroup, dataItem: this.grid.activeRow.dataItem });
    this.editHandler({ sender: this.grid, rowIndex: this.grid.activeRow.index - 1, dataItem: this.grid.activeRow.dataItem });
  }
  hasMultiColumns(ColumnsName: string) {
    if (!ColumnsName) return false;
    var columns = ColumnsName.split(",");
    return columns.length > 1;
  }

  getDetailLedgerParameter(apiName: string, columName: string) {
    let p1: string = "";
    if (!this.formGroup || !this.formGroup.controls["SubLedgerId"] || !this.formGroup.controls["SubLedgerId"].value) return p1;
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedgerId") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=1`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger2Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=2`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger3Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=3`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger4Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=4`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger5Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=5`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger6Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=6`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger7Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=7`;
    }
    return p1;
  }
  async setDropdownlist(apiName: string, columName: string) {
    if (apiName.includes("DetailLedgerWithSubLedgerId")) return;
    let p = this.getDetailLedgerParameter(apiName, columName);
    if (p === undefined) return;
    await this._httpCommonService
      .getList(apiName + p)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then((x) => {
        this.LookupData[columName] = x;
      });
  }
  getItemDisplayById(apiName: string, id: number, displayMember, valueMember: string, dataItem: any, columnName: string) {
    if (!id) return "";
    if (apiName.includes("Comment")) {
      return dataItem[columnName];
    }
    columnName = columnName.replace("Id", "");
    return dataItem[`${columnName}${displayMember}`];
  }
  getDateValue(date: Date) {
    if (!date) return "";
    let m: Moment = moment(date.toString()).locale("fa");
    return m.format("YYYY/MM/DD");
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.selectorService.setDataList("AccVoucherDetail", undefined);
    this.saveGridColumnInfo();
    this.LookupData = undefined;
    this.LookupIsLoading = undefined;
    this.DefaultValues = undefined;
    this.grid = undefined;
    this.mySelection = undefined;
    this.columns = undefined;
    this.formGroup = undefined;
    this._dataList = undefined;
    this._dataList = undefined;
    this.gridData = undefined;
    this.editedRow = undefined;
  }
  setValue(key: string, value: any) {
    if (!this.formGroup.controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
    else if (this.formGroup.controls[key].value !== value) this.formGroup.controls[key].setValue(value);
  }
  async setSubLedgerStandardComent(subLedger: SubLedger) {
    let ListItems: string[] = [];
    let LatinListItems: string[] = [];
    let id = subLedger ? subLedger.Id : this.formGroup.controls["SubLedgerId"].value;

    await this._httpCommonService
      .getList("SubLedgerStandardComment/GetBySubLedgerId/" + id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then((x: any[]) => {
        x.forEach((l) => {
          if (l.SubLedgerComment) ListItems.push(l.SubLedgerComment);
          if (l.SubLedgerLatinComment) ListItems.push(l.SubLedgerLatinComment);
        });
        this.LookupData["Comment"] = ListItems;
        this.LookupData["LatinComment"] = LatinListItems;
      });
  }
  selectionChange(event: any, columnName: string = undefined) {
    this.valueChanges.emit({ data: event, columnName: columnName });
    if (event && columnName && columnName === "SubLedgerId") {
      // this.dataReadedColumns = "";
      if (this.formGroup) {
        if (this.formGroup.controls["SubLedgerCode"].value !== event.Code) {
          this.setValue("SubLedgerCode", event.Code);
          this.setValue("SubLedgerTitle", event.Title);
          this.setValue("GroupLedgerCode", event.GroupLedgerCode);
          this.setValue("GroupLedgerTitle", event.GroupLedgerTitle);
          this.setValue("GeneralLedgerCode", event.GeneralLedgerCode);
          this.setValue("GeneralLedgerTitle", event.GeneralLedgerTitle);
          this.setValue("HasDetailLedger1", event.HasDetailLedger1);
          this.setValue("HasDetailLedger2", event.HasDetailLedger2);
          this.setValue("HasDetailLedger3", event.HasDetailLedger3);
          this.setValue("HasDetailLedger4", event.HasDetailLedger4);
          this.setValue("HasDetailLedger5", event.HasDetailLedger5);
          this.setValue("HasDetailLedger6", event.HasDetailLedger6);
          this.setValue("HasDetailLedger7", event.HasDetailLedger7);

          this.setValue("DetailLedgerId", undefined);
          this.setValue("DetailLedgerCode", undefined);
          this.setValue("DetailLedgerTitle", undefined);
          this.setValue("DetailLedger2Id", undefined);
          this.setValue("DetailLedger2Code", undefined);
          this.setValue("DetailLedger2Title", undefined);
          this.setValue("DetailLedger3Id", undefined);
          this.setValue("DetailLedger3Code", undefined);
          this.setValue("DetailLedger3Title", undefined);
          this.setValue("DetailLedger4Id", undefined);
          this.setValue("DetailLedger4Code", undefined);
          this.setValue("DetailLedger4Title", undefined);
          this.setValue("DetailLedger5Id", undefined);
          this.setValue("DetailLedger5Code", undefined);
          this.setValue("DetailLedger5Title", undefined);
          this.setValue("DetailLedger6Id", undefined);
          this.setValue("DetailLedger6Code", undefined);
          this.setValue("DetailLedger6Title", undefined);
          this.setValue("DetailLedger7Id", undefined);
          this.setValue("DetailLedger7Code", undefined);
          this.setValue("DetailLedger7Title", undefined);
          this.setValue("HasTrackNo", event.HasTrackNo);
          this.setValue("RequireTrackNo", event.RequireTrackNo);
        }
        this.columns
          .filter((x) => x.name.includes("DetailLedger"))
          .forEach((x) => {
            if (x.listVisible && x.apiName) this.setDropdownlist(x.apiName, x.name);
          });
        this.setSubLedgerStandardComent(event);

        this.setDisableColumn(this.formGroup.value);
      }
    }
    if (event && columnName && columnName === "DetailLedgerId") {
      if (this.formGroup) {
        this.setValue("DetailLedgerCode", event.Code);
        this.setValue("DetailLedgerTitle", event.Title);
      }
    }

    if (event && columnName && columnName === "DetailLedger2Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger2Code", event.Code);
        this.setValue("DetailLedger2Title", event.Title);
      }
    }
    if (event && columnName && columnName === "DetailLedger3Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger3Code", event.Code);
        this.setValue("DetailLedger3Title", event.Title);
      }
    }
    if (event && columnName && columnName === "DetailLedger4Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger4Code", event.Code);
        this.setValue("DetailLedger4Title", event.Title);
      }
    }
    if (event && columnName && columnName === "DetailLedger5Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger5Code", event.Code);
        this.setValue("DetailLedger5Title", event.Title);
      }
    }
    if (event && columnName && columnName === "DetailLedger6Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger6Code", event.Code);
        this.setValue("DetailLedger6Title", event.Title);
      }
    }
    if (event && columnName && columnName === "DetailLedger7Id") {
      if (this.formGroup) {
        this.setValue("DetailLedger7Code", event.Code);
        this.setValue("DetailLedger7Title", event.Title);
      }
    }
    if (this.formGroup) this.formGroup.updateValueAndValidity();
    this.cd.markForCheck();
    if (this.formGroup) this.valueChanges.emit(this.formGroup.value);
  }
  shouldBeChangedData(columnName: string): boolean {
    return !this.dataReadedColumns.includes(columnName);
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<any>> {
    var abs = new BehaviorSubject<PagingDataResult<any>>(null);

    if (columnName.includes("SubLedgerId")) {
      abs.next(this.LookupData[columnName]);
    } else {
      if (this.LookupIsLoading[columnName]) return abs.asObservable();
      let apiName: string = "DetailLedger/DetailLedgerWithSubLedgerId";
      let p = this.getDetailLedgerParameter(apiName, columnName);
      if (!p) return null;
      this.LookupIsLoading[columnName] = true;
      this._httpCommonService
        .get<PagingDataResult<any>>(apiName + p + `&searchValue=${searchValue}&skip=${skip}&take=${take}`)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (x) => {
            if (!this.dataReadedColumns.includes(columnName)) this.dataReadedColumns = this.dataReadedColumns + "," + columnName;
            if (x) abs.next(x);
            this.LookupIsLoading[columnName] = false;
          },
          (err) => (this.LookupIsLoading[columnName] = false)
        );
    }
    return abs.asObservable();
  }
  saveSubLedgerStandardComment() {
    if (!this.accountService.userHasPermission(`Accounting:SubLedgerStandardComment`, Permission.managePermission)) {
      this.sts.showDialog("شما دسترسی لازم جهت ذخیره شرح استاندارد را ندارید.", "هشدار");
      return;
    }
    if (!this.formGroup.controls["SubLedgerId"].value) {
      this.sts.showDialog("معین انتخاب نشده است.", "هشدار");
      return;
    }
    let entity: SubLedgerStandardComment = <SubLedgerStandardComment>{};

    entity.SubLedgerId = this.formGroup.controls["SubLedgerId"].value;
    entity.SubLedgerComment = this.formGroup.controls["Comment"].value;
    entity.SubLedgerLatinComment = this.formGroup.controls["LatinComment"].value;
    if (
      (entity.SubLedgerLatinComment || entity.SubLedgerComment) &&
      (!this.loadingData["Comment"] || !this.loadingData["Comment"].some((x) => x === entity.SubLedgerComment)) &&
      (!this.loadingData["LatinComment"] || !this.loadingData["LatinComment"].some((x) => x === entity.SubLedgerLatinComment))
    ) {
      this._httpCommonService
        .create("SubLedgerStandardComment", entity)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (row) => this.setSubLedgerStandardComent(undefined),
          (error) => {
            this.sts.showDialog(`${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
  }
  valueChange($event, columnName: string) {
    if (this.formGroup) this.formGroup.controls[columnName].setValue($event);
  }
  hasdatForPaset() {
    return this.selectorService.getDataList("AccVoucherDetail") !== undefined && (this.isAdd || this.isEdit);
  }
  copyHandler() {
    if (this.mySelection && this.mySelection.length > 0)
      this.selectorService.setDataList(
        "AccVoucherDetail",
        this.dataList.filter(
          (x) => x.State !== RowState.Delete && x.State !== RowState.Detached && this.mySelection.some((s) => s["RowNumber"] === x.RowNumber)
        )
      );
    else
      this.selectorService.setDataList(
        "AccVoucherDetail",
        this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached && x.RowNumber === this.editedRow.RowNumber)
      );
  }
  copyAll() {
    this.selectorService.setDataList(
      "AccVoucherDetail",
      this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
    );
  }
  pasetHandler() {
    this.cancelHandler();
    if (this.selectorService.getDataList("AccVoucherDetail") !== undefined) {
      this.selectorService.getDataList("AccVoucherDetail").forEach((element) => {
        const entity = Object.assign({}, element as AccVoucherDetail);
        entity.RowNumber = this.dataList.length + 1;
        entity.Id = 0;
        entity.State = RowState.New;
        this.dataList.push(entity);
      });
      this.setRowNumber();
      this.selectorService.setDataList("AccVoucherDetail", undefined);
      this.mySelection = [];
    }
  }
  public isRowSelected = (e: RowArgs) => this.mySelection.indexOf(e.dataItem.RowNumber) >= 0;
  movableUp(): boolean {
    return this.dataList.length > 1 && this.editedRow !== undefined && this.editedRow.RowNumber > 1;
  }
  movableDown(): boolean {
    return (
      this.dataList.length > 1 &&
      this.editedRow !== undefined &&
      this.editedRow.RowNumber < this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length
    );
  }
  moveUp() {
    let tempRow: number = this.editedRow.RowNumber;
    if (tempRow <= 1) return;
    if (this.dataList.find((x) => x.RowNumber === tempRow - 1).State === RowState.NoChange)
      this.dataList.find((x) => x.RowNumber === tempRow - 1).State = RowState.Modify;
    this.dataList.find((x) => x.RowNumber === tempRow - 1).RowNumber = tempRow;
    this.editedRow.RowNumber = tempRow - 1;
    if (this.editedRow.State === RowState.NoChange) this.editedRow.State = RowState.Modify;
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    this.mySelection = [this.editedRow.RowNumber];
  }
  moveDown() {
    let tempRow: number = this.editedRow.RowNumber;
    if (tempRow >= this.dataList.length) return;
    if (this.dataList.find((x) => x.RowNumber === tempRow + 1).State === RowState.NoChange)
      this.dataList.find((x) => x.RowNumber === tempRow + 1).State = RowState.Modify;
    this.dataList.find((x) => x.RowNumber === tempRow + 1).RowNumber = tempRow;
    this.editedRow.RowNumber = tempRow + 1;
    if (this.editedRow.State === RowState.NoChange) this.editedRow.State = RowState.Modify;
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    this.mySelection = [this.editedRow.RowNumber];
  }
  insertRow() {
    let currentRow = Object.assign({}, this.editedRow);
    this.editedRow = undefined;
    this.dataList
      .filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.RowNumber >= currentRow.RowNumber)
      .forEach((x) => {
        x.RowNumber = x.RowNumber + 1;
        if (x.State !== RowState.New) x.State = RowState.Modify;
      });
    this.isNew = true;
    if (!this.dataList) this.dataList = [];

    this.rowIsEditing = true;
    let _comment: string = "";
    if (this.headerTitleToDetailTitle) _comment = this.headerTitleToDetailTitle;
    const temp = <AccVoucherDetail>{ Id: -1, RowNumber: currentRow.RowNumber, State: RowState.New, Comment: _comment };
    this.dataList.push(temp);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    this.editedRowIndex = currentRow.RowNumber - 1;
    this.fitColumns();
    this.cd.markForCheck();
    this.setFormGroup(temp);
    if (this.grid) {
      this.grid.editRow(this.editedRowIndex, this.formGroup);
      this.rowinserted = true;
    }
  }

  setColumnInfo(columnInfos: GridColumnInfoDetail[]) {
    if (!this.grid)
      setTimeout(() => {
        this.setColumnInfo(columnInfos);
      }, 50);

    if (this.grid?.columns) {
      if (this.grid.columns.length <= 1) {
        setTimeout(() => this.setColumnInfo(columnInfos), 200);
      }
    }
    if (this.grid?.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        const column = columnInfos.find((c) => c.name === (x.field ?? x.title));
        if (column) {
          x.leafIndex = column.leaftindex;
          x.orderIndex = column.orderindex;
          x.minResizableWidth = column.minResizableWidth;
          x.width = column.width;
          x.hidden = column.hidden;
        }
      });
    }
    this.isFirstLoad = true;
    this.cd.detectChanges();
    setTimeout(() => {
      const firstCol: ScrollRequest = {};
      firstCol.column = 0;
      if (this.grid && firstCol) this.grid?.scrollTo(firstCol);
    }, 110);
  }
  setDefaultColumnInfo() {
    this.grid?.columns?.forEach((x: ColumnComponent) => {
      if (x.title === "عملیات") {
        x.width = 70;
        x.minResizableWidth = 60;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      if (!x.title && !x.field) {
        x.width = x.width;
        x.minResizableWidth = x.minResizableWidth;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      const column = this.columns.find((c) => c.name === (x.field ?? x.title));
      if (column) {
        x.width = column.columnWidth;
        x.minResizableWidth = x.minResizableWidth;
        x.hidden = !column.listVisible;

        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
    });
    this.cd.markForCheck();
  }
  async saveGridColumnInfo() {
    const list: GridColumnInfoDetail[] = [];
    if (this.grid && this.grid.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        if (x) {
          const column = new GridColumnInfoDetail();
          column.leaftindex = x.leafIndex;
          column.orderindex = x.orderIndex;
          column.hidden = x.hidden;
          column.name = x.field ?? x.title;
          column.width = x.width;
          column.minResizableWidth = x.minResizableWidth;
          column.title = x.title;
          list.push(column);
        }
      });
      if (!this._GridColumnInfo) this._GridColumnInfo = new GridColumnInfo();
      this._GridColumnInfo.Key = "AccVoucherDetail";
      this._GridColumnInfo.ColumnInfo = JSON.stringify(list);
      this._GridColumnInfo.CreatedUserId = this.accountService.authService.currentUser.Id;
      if (this.state.group && this.state.group.length > 0) this._GridColumnInfo.Group = JSON.stringify(this.state.group);
      else this._GridColumnInfo.Group = undefined;
      await this._httpCommonService.updateItem("MisSetUp/UpdateGridColumnInfo", this._GridColumnInfo).pipe(takeUntil(this.ngUnsubscribe)).toPromise();
    }
  }
  async fitColumns() {
    if (!this.isFirstLoad) {
      if (this._GridColumnInfo) {
        let columnInfos: GridColumnInfoDetail[] = JSON.parse(this._GridColumnInfo.ColumnInfo);
        this.setColumnInfo(columnInfos);
      } else {
        const x = await this._httpCommonService
          .get("MisSetUp/GetGridColumnInfo/?key=" + "AccVoucherDetail" + `&CreatedUserId=${this.accountService.authService.currentUser.Id}`)
          .pipe(takeUntil(this.ngUnsubscribe))
          .toPromise();
        if (x) {
          this._GridColumnInfo = x as unknown as GridColumnInfo;
          this.setColumnInfo(JSON.parse(x["ColumnInfo"]));
          if (this._GridColumnInfo.Group) {
            this.state.group = JSON.parse(x["Group"]);
          }
        } else this.setDefaultColumnInfo();

        this.isFirstLoad = true;
      }
    }
    setTimeout(
      () => {
        this.cd.detectChanges();
        this.cd.markForCheck();
      },
      this.isFirstLoad ? 500 : 200
    );

    this.cd.markForCheck();
  }
  getSumWithKey(list: any[], key: string): number {
    if (list.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length <= 0) return 0;
    return list
      .filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
      .reduce((s: number, b: number) => (s ?? 0) + (b[key] ?? 0), 0);
  }
  getColumnAggregates(columnName: string) {
    if (columnName === "RowNumber") return this.dataList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)?.length ?? 0;
    if (this.dataList && this.dataList.length > 0) return this.dataList?.getSumWithKey(columnName);
    return undefined;
  }
  hasAggregate(columnName: string) {
    return this.aggregatesColumnName !== undefined && this.aggregatesColumnName.includes(columnName);
  }
  public onUserRowSelect({ sender, column, rowIndex, columnIndex, dataItem }): void {
    this.editedRow = dataItem;
    if (!this.mySelection) this.mySelection = [];
    if (!this.mySelection.some((x) => x["RowNumber"] === this.editedRow.RowNumber)) this.mySelection.push(dataItem);
    this.valueChanges.emit(this.editedRow);
  }
  // onKeyup($event) {
  //   if ($event.key === 'Escape' && !document.getElementsByClassName("popovermaincontent")) {
  //     this.cd.markForCheck();
  //     this.formGroup.updateValueAndValidity();
  //     if (!(this.formGroup && (this.formGroup.touched || this.formGroup.dirty)))
  //     {
  //       console.log('Lookup', $event.returnValue);
  //       console.log('accvoucher');
  //       $event.preventDefault();
  //       $event.stopPropagation();
  //       console.log('Lookup', $event.returnValue);
  //       this.cancelHandler();
  //     }
  //   }
  // }
}
